<template>
    <div class="front">
        <v-app id="inspire" style="overflow: hidden;">
            <NavBar v-if="$route.meta.showNav"></NavBar>
            <router-view></router-view>
        </v-app>
    </div>
</template>
<script>
    import NavBar from './components/NavBar'
    import {mapGetters, mapMutations} from 'vuex'

    export default {
        name: "performance",
        components: {
            NavBar
        },
        data() {
            return {
                userInfo: {
                    avatar: '',
                    name: ''
                },
                code: '',
                openId: ''
            }
        },
        computed: {

        },
        methods: {
            getQueryString(name) {
                let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
                let r = window.location.search.substr(1).match(reg);
                if (r != null)
                    return decodeURI(r[2]);
                return null;
            },
        },
        mounted() {
        },
        watch: {

        }
    }
</script>

<style lang="scss" scoped>
    @import '../../styles/vars.scss';

    .slider {
        background: rgba(191, 217, 214, 1);
    }

    .epmc-head {
        max-width: 640px;
        margin: 0px auto;
        left: 0;
        right: 0;
    }

    .epmc-container {
        height: 100%;
        max-width: 640px;
        margin: 0px auto;
        position: relative;
        padding: 65px 15px 15px 15px;

        /*.epmc-head {*/
        /*    position: relative;*/
        /*    top: 15px;*/
        /*    padding: 10px;*/
        /*    box-sizing: border-box;*/
        /*    background: #18c79c;*/
        /*    width: 100%;*/
        /*    height: auto;*/
        /*}*/

        /*.epmc-swiper {*/
        /*    !*background: #18c79c;*!*/
        /*    !*min-height: 100vh;*!*/
        /*    !*max-height: 40vh;*!*/
        /*    height:100vh;*/
        /*    top: 10px;*/
        /*    width: 100%;*/
        /*    !*overflow-y: scroll;*!*/
        /*}*/
    }

    .epmc-footer {
        position: absolute;
        bottom: 0px;
        right: 0px;
        left: 0px;
        max-width: 640px;
        width: auto;
        box-sizing: border-box;
        text-align: center;
        margin: 0px auto;
    }

    .week-title {
        color: #fff;
        text-align: center;
        padding-top: 15px;
    }

    .week-content {
        padding: 40px;
        overflow-y: auto;
        max-height: 40vh;
    }
</style>



// WEBPACK FOOTER //
// Front.vue?3fc384c6